<!-- eslint-disable prettier/prettier -->
<div class="settings-page">

	<!-- ─── Header de página ────────────────────────────────────────────────── -->
	<div class="settings-wrap">
		<button class="settings-page-header__back-btn" (click)="navigateBack()">
			<lucide-icon
				name="arrow-left"
				[size]="24"
				[strokeWidth]="1.5"
				color="#5f1f7b"
			></lucide-icon>
			<span>Volver a Trámites VL</span>
		</button>
	</div>

	<!-- ─── Contenido principal ─────────────────────────────────────────────── -->
	<div class="settings-wrap settings-wrap--main">

		<div class="settings-page-header__titles">
			<h1 class="settings-page-header__title">MI PERFIL</h1>
			<p class="settings-page-header__subtitle">
				Podés actualizar tus datos cuando lo necesites
			</p>
		</div>

		<!-- ─── Perfil ──────────────────────────────────────────────────────── -->
		<div class="profile-card">
			<div class="profile-card__header">
				<div class="profile-card__avatar">{{ profileInitials }}</div>
				<div>
					<p class="profile-card__name">{{ userData()?.nombre }} {{ userData()?.apellido }}</p>
					<span class="profile-card__level">Nivel {{ profileNivel }}</span>
				</div>
			</div>
		</div>

		<!-- ─── Información personal ────────────────────────────────────────── -->
		<div class="data-box">
			<app-user-settings-personal-info
				[requestForm]="requestForm"
				[userData]="userData"
				[modoEdicion]="modoEdicion"
				[soloLectura]="!editandoPersonal()"
				(formData)="onPersonalInfoChange($event)"
				(editarClick)="editandoPersonal.set(true)"
				(guardarClick)="guardarPersonal()"
				(cancelarClick)="cancelarPersonal()"
			/>
		</div>

		<!-- ─── Datos de contacto ────────────────────────────────────────────── -->
		<div class="data-box">
			<div class="section-header">
				<p class="section-title">Datos de contacto</p>
				@if (!editandoContactos()) {
				<button mat-button class="section-edit-btn" (click)="editandoContactos.set(true)">
					<lucide-icon
						name="pencil"
						[size]="16"
						[strokeWidth]="1.5"
						color="#5f1f7b"
					></lucide-icon>
					Editar
				</button>
				} @else {
				<div class="section-header__actions">
					<button mat-flat-button class="section-save-btn" (click)="guardarContactos()">
						Guardar
					</button>
					<button mat-button class="section-cancel-btn" (click)="cancelarContactos()">
						Cancelar
					</button>
				</div>
				}
			</div>
			<app-user-settings-contacts
				[requestForm]="requestForm"
				[contactsData]="contactsData"
				[modoEdicion]="modoEdicion"
				[soloLectura]="!editandoContactos()"
				(contactsChange)="onContactsChange($event)"
			/>
		</div>

		<!-- ─── Domicilio ────────────────────────────────────────────────────── -->
		<div class="data-box">
			<div class="section-header">
				<p class="section-title">Domicilio</p>
				@if (!editandoDomicilios()) {
				<button
					mat-button
					class="section-edit-btn"
					(click)="editandoDomicilios.set(true)"
				>
					<lucide-icon
						name="pencil"
						[size]="16"
						[strokeWidth]="1.5"
						color="#5f1f7b"
					></lucide-icon>
					Editar
				</button>
				} @else {
				<div class="section-header__actions">
					<button mat-flat-button class="section-save-btn" (click)="guardarDomicilios()">
						Guardar
					</button>
					<button mat-button class="section-cancel-btn" (click)="cancelarDomicilios()">
						Cancelar
					</button>
				</div>
				}
			</div>
			<app-user-settings-address
				[requestForm]="requestForm"
				[addressesData]="addressesData"
				[modoEdicion]="modoEdicion"
				[soloLectura]="!editandoDomicilios()"
				(addressesChange)="onAddressesChange($event)"
			/>
		</div>

		<!-- ─── Seguridad ────────────────────────────────────────────────────── -->
		<div class="security-card">
			<div class="section-header">
				<p class="section-title">Seguridad</p>
			</div>
			<div class="security-content">
				<button
					mat-button
					class="security-btn"
					(click)="cambiarContrasena()"
				>
					<lucide-icon
						name="lock"
						[size]="16"
						[strokeWidth]="1.5"
						color="#131416"
					></lucide-icon>
					Cambiar contraseña
				</button>

				<button
					mat-button
					class="security-btn"
					[disabled]="!puedeSubirDeNivel"
					(click)="subirDeNivel()"
				>
					<lucide-icon
						name="circle-arrow-up"
						[size]="16"
						[strokeWidth]="1.5"
						color="#131416"
					></lucide-icon>
					Subir de nivel
				</button>

				<button
					mat-button
					class="security-btn security-btn--logout"
					(click)="cerrarSesion()"
				>
					<lucide-icon
						name="log-out"
						[size]="16"
						[strokeWidth]="1.5"
						color="#b91c1c"
					></lucide-icon>
					Cerrar sesión
				</button>
			</div>
			<div class="security-divider"></div>
			<p class="security-deregister">
				Si querés eliminar tu cuenta, escribinos a
				<a href="mailto:info.identidaddigital@vicentelopez.gov.ar"
					>{{"info.identidaddigital@vicentelopez.gov.ar"}}</a
				>.
			</p>
		</div>

	</div>
</div>
